/**
 * @generated SignedSource<<6761f422d382a731fa9666f25faae8a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSidePanelNotes_project$data = {
  readonly id: number;
  readonly isTemplate: boolean;
  readonly notes: ReadonlyArray<{
    readonly created_at: string;
    readonly id: number;
    readonly note: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectNote_note">;
  }>;
  readonly " $fragmentType": "ProjectSidePanelNotes_project";
};
export type ProjectSidePanelNotes_project$key = {
  readonly " $data"?: ProjectSidePanelNotes_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSidePanelNotes_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSidePanelNotes_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "isTemplate",
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "created_at": "asc"
          }
        }
      ],
      "concreteType": "notes",
      "kind": "LinkedField",
      "name": "notes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created_at",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectNote_note"
        }
      ],
      "storageKey": "notes(order_by:{\"created_at\":\"asc\"})"
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "83e380695d3b6e177eef69a52534828b";

export default node;
